// client/src/services/inboxApi.js
// API service for the unified Social Inbox

export async function fetchInbox(tenantId, filters = {}) {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v !== undefined && v !== null && v !== '') params.set(k, String(v));
  }
  const res = await fetch(`/api/inbox/${tenantId}?${params}`, { credentials: 'include' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Failed to fetch inbox');
  return data;
}

export async function syncInbox(tenantId, options = {}) {
  const res = await fetch(`/api/inbox/${tenantId}/sync`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(options),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Sync failed');
  return data;
}

export async function markRead(tenantId, id, isRead = true) {
  const res = await fetch(`/api/inbox/${tenantId}/${id}/read`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ is_read: isRead ? 1 : 0 }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function markReplied(tenantId, id, isReplied = true) {
  const res = await fetch(`/api/inbox/${tenantId}/${id}/replied`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ is_replied: isReplied ? 1 : 0 }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function sendReply(tenantId, id, text) {
  const res = await fetch(`/api/inbox/${tenantId}/${id}/reply`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ text }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Reply failed');
  return data;
}

export async function hideReply(tenantId, id, hide = true) {
  const res = await fetch(`/api/inbox/${tenantId}/${id}/hide`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ hide }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Hide failed');
  return data;
}
